<template>
  <div v-if="user._id" :class="[$options.name]" @click="toggle">
    <div class="menu-group">
      <div v-if="isDisplayBasket" class="show-basket">
        <img v-if="false" class="avatar" :src="user.profilePicture" />
        <div v-else class="show-icon-menu">
          <i class="icon icon-avatar" />
        </div>
        <i class="icon icon-basket" @click="e => toggleBasket(e)" />
      </div>
      <img v-else-if="false" class="avatar" :src="user.profilePicture" />
      <div v-else class="show-icon-menu">
        <i class="icon icon-avatar" />
      </div>
      <div :class="['menubox', { visible: visible }]">
        <!-- <button v-show="visible" class="toggle">{{ user.email }}</button> -->
        <div v-show="visible" class="modal"></div>
        <ul v-show="visible" class="menus">
          <li class="menus-user">{{ user.email }}</li>
          <li @click="logOut">
            <button>
              <img
                src="../../../../img/icon-user-menu/Log-out.png"
                class="menu-user-icon"
              />
              <p class="menu-user-text">Sign out</p>
            </button>
          </li>
        </ul>
      </div>
    </div>
    <Basket
      :is-open="isShowBasketOverlay"
      :close-basket="() => closeBasket()"
    ></Basket>
  </div>
</template>

<script>
'use strict'
import { mapGetters, mapState, mapMutations } from 'vuex'
import { isEmpty } from 'lodash'

import Basket from '@/components/ui/styled/basket'

import signOut from '../../../graphql/account/signOut.graphql'
import CONSTANTS from '@/config/url'
import {
  isRouteRateAndReview,
  showBookForIcon
} from '@/helpers/checkPermitRoute'

export default {
  name: 'DropdownMenuNew',
  components: {
    Basket
  },
  props: ['user', 'disabledViewProfileOptions'],
  data: function() {
    return {
      visible: false
    }
  },
  computed: {
    ...mapGetters('account', ['userGroup', 'getUserRole']),
    ...mapState('account', ['bookFor']),
    ...mapGetters('basket', ['isShowBasketOverlay', 'myBasket']),
    isDisplayBasket() {
      // eslint-disable-next-line no-unused-vars
      const hasBookFor = !isEmpty(this.bookFor)
      const hasBasketItem = this.myBasket && this.myBasket.length > 0
      const showIcon = showBookForIcon(this.$route, this.userGroup)
      // const isVenueAdmin =
      //   this.userGroup === 'venue' && this.getUserRole === 'admin'
      // const basketPage = this.$route.fullPath === '/basket'
      return (
        hasBasketItem &&
        showIcon &&
        !this.$route.meta.hideBasker &&
        !isRouteRateAndReview(this.$router.currentRoute.fullPath)
      )
    }
  },
  methods: {
    ...mapMutations('basket', ['toggleBasketOverlay']),
    isShowProfile() {
      if (this.user && this.user.companies.length > 0) {
        return (
          this.user.companies[0].type === 'venue' &&
          !this.disabledViewProfileOptions
        )
      }
      return false
    },
    async logOut() {
      try {
        window.location.href = CONSTANTS.ACCOUNT.SIGNIN
        let result = await this.$apollo.mutate({
          mutation: signOut
        })
        if (result.data.signOut.success) {
          this.$store.dispatch('basket/removeAllBasket')
          this.$store.dispatch('account/SIGN_OUT')
          localStorage.clear()
          // this.$router.push(CONSTANTS.ACCOUNT.SIGNIN)
        }
      } catch (err) {
        this.$store.dispatch('basket/removeAllBasket')
        this.$store.dispatch('account/SIGN_OUT')
        // TODO: log a proper message here
        // We should add a proper Error handle here but in any cases
        // User should be redirected to login page after clearing local storage
        localStorage.clear()
        // this.$router.push(CONSTANTS.ACCOUNT.SIGNIN)
      }
    },
    toggle: function() {
      this.visible = !this.visible
    },
    toggleBasket(e) {
      e.stopPropagation()
      const { toggleBasketOverlay, isShowBasketOverlay } = this
      toggleBasketOverlay(!isShowBasketOverlay)
    },
    closeBasket() {
      const { toggleBasketOverlay } = this
      toggleBasketOverlay(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.DropdownMenuNew {
  .menu-group {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    float: right;
    .avatar {
      width: 35px;
      height: 35px;
      background-color: $shade2;
      border-radius: 50%;
      margin-right: 19px;

      @include for-mobile {
        margin-right: 0;
      }
    }
    .show-icon-menu {
      margin-right: 15px;
      width: 35px;
      height: 35px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      .icon:before {
        color: $shade1;
        font-size: 23px;
      }
    }
    .show-basket {
      display: flex;
      justify-content: space-evenly;
      color: $shade10;
      width: 100px;
      height: 35px;
      text-align: center;
      align-items: center;
      .icon:before {
        color: $shade1;
        font-size: 23px;
      }
    }
    .menubox {
      position: relative;
      .modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
      }
      button {
        outline: none;
        background-color: transparent;
      }
      .menus {
        position: absolute;
        right: 15px;
        top: 15px;
        width: 200px;
        padding: 7px 0;
        border-radius: 4px;
        list-style: none;
        background-color: $shade1;
        box-shadow: 0 5px 15px 1px rgba(0, 0, 0, 0.15);
        &.visible {
          visibility: visible;
        }
        button {
          outline: none;
          display: flex;
          .menu-user-text {
            margin: auto;
            margin-left: 10px;
          }
        }
        li {
          @include sf-font(1.3rem, #4d4f5c);
          padding: 7px 16px;
          vertical-align: middle;
          cursor: pointer;
          &:hover {
            background-color: rgba(163, 160, 251, 0.07);
          }
          button {
            outline: none;
          }
          .menu-user-icon {
            width: 16px;
            height: 16px;
          }
          &.delete {
            color: #ff6841;
          }
          &:before {
            font-size: 2rem;
            margin-right: 10px;
          }
        }

        .menus-user {
          display: none;
        }

        @include mobile {
          left: -180px;
          top: 30px;
          width: 180px;

          .menus-user {
            display: block;
          }
        }
      }
    }
  }
}
</style>
